import Vue from 'vue'
import Router from 'vue-router'

import Header from '@/components/header'
import Footer from '@/components/footer'
// 流量中心侧边栏
import Sidebar from '@/components/sidebar'
import Login from '@/views/login/login'
import Register from '@/views/register/register'
// 首页
import Home from '@/views/home/home'
// 流量中心
import FlowCenter from '@/views/flowCenter/flowCenter'
// 淘宝任务
import TbTask from '@/views/tbTask/tbTask'
import TbPc from '@/views/tbPc/tbPc'
import TbLike from '@/views/tbLike/tbLike'
import TbPassw from '@/views/tbPassw/tbPassw'
// 个人中心
import UserCenter from '@/views/userCenter/userCenter'
// 淘宝收藏任务
import TbCollection from '@/views/tbCollection/tbCollection'
// 淘宝加购任务
import TbAdd from '@/views/tbAdd/tbAdd'
// 旺旺打标
import Wangwang from '@/views/wangwang/wangwang'

// 京东APP任务
import JdAPP from '@/views/jdAPP/jdAPP'
// 京东收藏任务
import JdCollection from '@/views/jdCollection/jdCollection'
// 京东直接收藏
import JdDirectCollection from '@/views/jdDirectCollection/jdDirectCollection'
// 京东搜索收藏
import JdSearchCollection from '@/views/jdSearchCollection/jdSearchCollection'
// 京东加购任务
import JdAdd from '@/views/jdAdd/jdAdd'
// 京东直接加购
import JdDirectAdd from '@/views/jdDirectAdd/jdDirectAdd'



// 拼多多App流量任务
import PddApp from '@/views/pddApp/pddApp'
import PddCollection from '@/views/pddCollection/pddCollection'
// 平多多商品收藏
import PddGoodCollection from '@/views/pddGoodCollection/pddGoodCollection'
// 拼多多店铺收藏
import PddShopCollection from '@/views/pddShopCollection/pddShopCollection'



// 任务模板
import TaskTemplate from '@/views/taskTemplate/taskTemplate'
// 任务查询
import TaskSearch from '@/views/taskSearch/taskSearch'
// 点赞
import Linkes from '@/views/linkes/linkes'
// 空页面，指向支付
import Pay from '@/views/pay/pay'
// 淘宝每日好店
import TbDayGood from '@/views/tbDayGood/tbDayGood'
// 淘宝商品收藏
import TbGoodCollection from '@/views/tbGoodCollection/tbGoodCollection'
// 淘宝店铺收藏
import TbShopCollection from '@/views/tbShopCollection/tbShopCollection'
// 淘宝聚划算
import TbJuhuasuan from '@/views/tbJuhuasuan/tbJuhuasuan'
// 直接加购
import TbDirectPurchase from '@/views/tbDirectPurchase/tbDirectPurchase'
// 淘抢购
import TbRushToBuy from '@/views/tbRushToBuy/tbRushToBuy'
// 淘宝达人关注
import TbDaRen from '@/views/tbDaRen/tbDaRen'
// 淘宝直播
import TbLive from '@/views/tbLive/tbLive'
// 逛逛点赞
import GuangGuang from '@/views/guangguang/guangguang'
// 抖音关注
import DouyinFollow from '@/views/douyin/douyinFollow'
// 抖音点赞
import DouyinAdd from '@/views/douyin/douyinAdd'
// 抖音播放
import DouyinPlay from '@/views/douyin/douyinPlay'



Vue.use(Router)
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
export default new Router({
  routes: [{
    path: '/',
    name: 'Header',
    component: Header,
    redirect: '/home'
  },
  {
    path: '/',
    name: 'Footer',
    component: Footer
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {title:'登录'}
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {title:'注册'}
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/flowCenter',
    name: 'FlowCenter',
    component: FlowCenter
  },
  {
    path: '/',
    name: 'Sidebar',
    component: Sidebar
  },
  {
    path: '/tbTask',
    name: 'TbTask',
    component: TbTask
  },
  {
    path: '/tbPc',
    component: TbPc,
    name:'tbPc'
  },
  {
    path: '/tbLike',
    component: TbLike,
    name:'tbLike'
  },
  {
    path: '/tbPassw',
    component: TbPassw,
    name:'tbPassw'
  },
  {
    path: '/userCenter',
    component: UserCenter,
    name:'userCenter'
  },
  {
    path: '/jdAPP',
    component: JdAPP,
    name:'jdAPP'
  },
  {
    path: '/jdCollection',
    component: JdCollection,
    name:'jdCollection'
  },
  {
    path: '/jdAdd',
    component: JdAdd,
    name:'jdAdd'
  },
  {
    path: '/pddApp',
    component: PddApp,
    name:'pddApp'
  },
  {
    path: '/pddCollection',
    component: PddCollection,
    name:'pddCollection'
  },
  {
    path: '/taskTemplate',
    component: TaskTemplate,
    name:'taskTemplate'
  },
  {
    path: '/taskSearch',
    component: TaskSearch,
    name:'taskSearch'
  },
  {
    path: '/tbCollection',
    component: TbCollection,
    name:'tbCollection'
  },
  {
    path: '/tbAdd',
    component: TbAdd,
    name:'tbAdd'
  },
  {
    path: '/jdCollection',
    component: JdCollection,
    name:'jdCollection'
  },
  {
    path: '/jdAdd',
    component: JdAdd,
    name:'jdAdd'
  },
  {
    path: '/pddCollection',
    component: PddCollection,
    name:'pddCollection'
  },
  {
    path: '/wangwang',
    component: Wangwang,
    name:'wangwang'
  },
  {
    path: '/linkes',
    component: Linkes,
    name:'linkes'
  },
  {
    path: '/pay',
    component: Pay,
    name:'pay'
  },
  {
    path: '/tbDayGood',
    component: TbDayGood,
    name:'tbDayGood'
  },
  {
    path: '/tbGoodCollection',
    component: TbGoodCollection,
    name:'tbGoodCollection'
  },
  {
    path: '/tbShopCollection',
    component: TbShopCollection,
    name:'tbShopCollection'
  },
  {
    path: '/tbJuhuasuan',
    component: TbJuhuasuan,
    name:'tbJuhuasuan'
  },
  {
    path: '/tbDirectPurchase',
    component: TbDirectPurchase,
    name:'tbDirectPurchase'
  },
  {
    path: '/tbRushToBuy',
    component: TbRushToBuy,
    name:'tbRushToBuy'
  },
  {
    path: '/tbDaRen',
    component: TbDaRen,
    name:'tbDaRen'
  },
  {
    path: '/tbLive',
    component: TbLive,
    name:'tbLive'
  },
  {
    path: '/jdDirectCollection',
    component: JdDirectCollection,
    name:'jdDirectCollection'
  },
  {
    path: '/jdSearchCollection',
    component: JdSearchCollection,
    name:'jdSearchCollection'
  },
  {
    path: '/jdDirectAdd',
    component: JdDirectAdd,
    name:'jdDirectAdd'
  },
  {
    path: '/pddGoodCollection',
    component: PddGoodCollection,
    name:'pddGoodCollection'
  },
  {
    path: '/pddShopCollection',
    component: PddShopCollection,
    name:'pddShopCollection'
  },
  {
    path: '/guangguang',
    component: GuangGuang,
    name:'guangguang'
  },
  {
    path: '/douyinFollow',
    component: DouyinFollow,
    name:'douyinFollow'
  },
  {
    path: '/douyinAdd',
    component: DouyinAdd,
    name:'douyinAdd'
  },
  {
    path: '/douyinPlay',
    component: DouyinPlay,
    name:'douyinPlay'
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js